import { render, staticRenderFns } from "./thread-ai-view.vue?vue&type=template&id=dcd21f44"
import script from "./thread-ai-view.vue?vue&type=script&lang=js"
export * from "./thread-ai-view.vue?vue&type=script&lang=js"
import style0 from "./thread-ai-view.vue?vue&type=style&index=0&id=dcd21f44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports